/* src/app/modules/taxes/model-180/model-180.component.css */
:host {
  --m180-brand: #e3fd64;
  --m180-brand-d: #4d7a00;
  --m180-brand-bg: rgba(227, 253, 100, 0.08);
  --m180-text: #1a1d23;
  --m180-muted: #6b7280;
  --m180-border: #e5e7eb;
  --m180-surface: #ffffff;
  --m180-radius: 10px;
  --m180-shadow: 0 2px 8px rgba(0,0,0,0.07);
  display: block;
}
.m180-page {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.m180-header {
  display: flex;
  align-items: center;
  gap: 14px;
}
.m180-header__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: var(--m180-brand-bg);
  flex-shrink: 0;
}
.m180-header__icon mat-icon {
  font-size: 26px;
  width: 26px;
  height: 26px;
  color: var(--cf-brand-dark);
}
.m180-header__title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: var(--cf-text);
  line-height: 1.2;
}
.m180-header__sub {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--cf-text-muted);
}
.m180-status {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}
.m180-status__file {
  font-size: 12px;
  color: var(--cf-text-muted);
  word-break: break-all;
}
.m180-pill {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  border: 1px solid var(--cf-border);
  background: var(--cf-surface);
  color: var(--cf-text-muted);
}
.m180-pill--success {
  border-color: #bbf7d0;
  background: #f0fdf4;
  color: #15803d;
}
.m180-pill--info {
  border-color: #bfdbfe;
  background: #eff6ff;
  color: #1d4ed8;
}
.m180-pill--warning {
  border-color: #fde68a;
  background: #fffbeb;
  color: #b45309;
}
.m180-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.m180-alerts {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.m180-alert {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-left: 4px solid var(--cf-error);
  border-radius: var(--cf-radius);
  color: var(--cf-text);
}
.m180-alert--warning {
  background: #fffbeb;
  border-color: #fde68a;
  border-left-color: var(--cf-warning);
}
.m180-alert mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
}
.m180-alert__text {
  flex: 1 1 auto;
  font-size: 13px;
}
.m180-alert__link {
  font-size: 12px;
  font-weight: 600;
  color: var(--cf-brand-dark);
  cursor: pointer;
  white-space: nowrap;
  background: none;
  border: none;
  padding: 0;
}
.m180-alert__link:hover {
  text-decoration: underline;
}
.m180-guia {
  border: 1px solid #bbf7d0;
  background: #f0fdf4;
  border-radius: var(--cf-radius-lg);
  padding: 12px 16px;
}
.m180-guia__head {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #15803d;
}
.m180-guia__head mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.m180-guia__close {
  margin-left: auto;
  border: 0;
  background: none;
  color: #15803d;
  cursor: pointer;
  padding: 0;
}
.m180-guia__pasos {
  margin: 8px 0 10px 0;
  padding-left: 22px;
  font-size: 12.5px;
  color: var(--cf-text);
}
.m180-guia__pasos li {
  margin-bottom: 3px;
}
.m180-fields {
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: 8px 12px;
  align-items: end;
}
.m180-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  grid-column: span 3;
}
.m180-field--3 {
  grid-column: span 3;
}
.m180-field--4 {
  grid-column: span 4;
}
.m180-field--5 {
  grid-column: span 5;
}
.m180-field--6 {
  grid-column: span 6;
}
.m180-field--8 {
  grid-column: span 8;
}
.m180-field--toggle {
  justify-content: center;
  padding-bottom: 12px;
}
.m180-field ::ng-deep .mb-3,
.m180-tipo ::ng-deep .mb-3 {
  margin-bottom: 0 !important;
}
.m180-apartado {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--cf-border);
}
.m180-apartado:last-child {
  border-bottom: none;
  padding-bottom: 0;
}
.m180-apartado__titulo {
  margin: 0;
  font-size: 13.5px;
  font-weight: 700;
  line-height: 1.4;
  color: var(--cf-text);
}
.m180-recuadro {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  border: 1px solid var(--cf-border);
  border-radius: var(--cf-radius);
  background: var(--cf-bg);
}
.m180-recuadro__titulo {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--cf-text-muted);
}
.m180-recuadro__fila {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}
.m180-recuadro__fila--2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.m180-tabla {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.m180-tabla__fila {
  display: grid;
  grid-template-columns: minmax(160px, 1fr) repeat(3, minmax(0, 1.2fr));
  gap: 12px;
  align-items: center;
}
.m180-tabla__fila--cab {
  align-items: end;
}
.m180-tabla__col {
  font-size: 12.5px;
  font-weight: 600;
  line-height: 1.35;
  color: var(--cf-text);
}
.m180-tabla__desc {
  font-size: 12.5px;
  color: var(--cf-text-muted);
}
.m180-celda {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.m180-celda__label {
  font-size: 12.5px;
  color: var(--cf-text-muted);
}
.m180-celda__label:empty {
  display: none;
}
.m180-celda__control {
  display: flex;
  align-items: center;
  gap: 6px;
}
.m180-cas {
  flex: 0 0 auto;
  font-size: 11px;
  font-weight: 700;
  color: var(--m180-brand-d);
  white-space: nowrap;
  letter-spacing: .3px;
}
.m180-input {
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
  height: 34px;
  padding: 6px 10px;
  border: 1px solid var(--cf-border);
  border-radius: 8px;
  font-size: 13px;
  text-align: right;
  color: var(--cf-text);
  background: var(--cf-surface);
  box-sizing: border-box;
}
.m180-input:focus {
  outline: none;
  border-color: var(--m180-brand);
}
.m180-input--calc {
  background: #eceff1;
  color: var(--cf-text);
  font-weight: 600;
}
.m180-help {
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  padding: 0;
  border: 1px solid var(--cf-border);
  border-radius: 50%;
  background: var(--cf-surface);
  color: var(--cf-text-muted);
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
}
.m180-help:hover {
  border-color: var(--m180-brand);
  color: var(--cf-text);
}
.m180-total {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(200px, 280px);
  align-items: center;
  gap: 16px;
  padding: 6px 0;
  border-bottom: 1px solid var(--cf-border);
  font-size: 13px;
  color: var(--cf-text);
}
.m180-total:last-child {
  border-bottom: none;
}
.m180-total--resultado {
  font-weight: 700;
}
.m180-total__desc {
  line-height: 1.5;
}
.m180-tipo {
  margin-top: 4px;
}
.m180-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 48px 24px;
}
.m180-loading p {
  margin: 0;
  font-size: 14px;
  color: var(--cf-text-muted);
}
@media (max-width: 992px) {
  .m180-recuadro__fila,
  .m180-recuadro__fila--2 {
    grid-template-columns: minmax(0, 1fr);
  }
  .m180-tabla__fila {
    grid-template-columns: minmax(0, 1fr);
    gap: 6px;
  }
  .m180-tabla__fila--cab > span:first-child {
    display: none;
  }
  .m180-total {
    grid-template-columns: minmax(0, 1fr);
    gap: 6px;
  }
}
@media (max-width: 768px) {
  .m180-page {
    padding: 16px;
  }
  .m180-actions {
    flex-direction: column;
    align-items: stretch;
  }
  .m180-actions .cf-btn {
    width: 100%;
  }
  .m180-fields {
    grid-template-columns: minmax(0, 1fr);
  }
  .m180-field {
    grid-column: span 1 !important;
  }
}
.m180-field--2 {
  grid-column: span 2;
}
.m180-field--7 {
  grid-column: span 7;
}
.m180-field--9 {
  grid-column: span 9;
}
.m180-field--12 {
  grid-column: span 12;
}
.m180-resumen {
  display: grid;
  grid-template-columns: minmax(200px, 1fr) repeat(2, minmax(0, 1.2fr));
  gap: 10px 12px;
  align-items: center;
}
@media (max-width: 992px) {
  .m180-resumen {
    grid-template-columns: minmax(0, 1fr) repeat(2, minmax(0, 1fr));
  }
}
.m180-layout {
  display: grid;
  grid-template-columns: 240px minmax(0, 1fr);
  gap: 20px;
  align-items: start;
  padding-top: 4px;
}
.m180-rail {
  position: sticky;
  top: 12px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.m180-rail__block {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.m180-rail__label {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--cf-text);
}
.m180-rail__buscador {
  display: flex;
  gap: 6px;
  align-items: stretch;
}
.m180-rail__buscador .cf-btn {
  white-space: nowrap;
  flex: 0 0 auto;
  padding: 0 12px;
}
.m180-rail__input {
  flex: 1 1 auto;
  min-width: 0;
  text-align: left;
}
.m180-rail__nota {
  font-size: 11.5px;
  color: var(--cf-text-muted);
  word-break: break-all;
}
.m180-rail__seccion {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  margin-bottom: 2px;
  padding: 7px 10px;
  border: 0;
  border-radius: 6px;
  background: none;
  font: inherit;
  font-size: 12.5px;
  color: var(--m180-brand-d);
  text-align: left;
  cursor: pointer;
}
.m180-rail__seccion-texto {
  flex: 1 1 auto;
}
.m180-rail__seccion-numero {
  font-weight: 700;
}
.m180-sections {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.m180-actions__spacer {
  flex: 1 1 auto;
  min-width: 0;
}
.m180-presentar {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.m180-card__body ::ng-deep .mb-3 {
  margin-bottom: 0 !important;
}
@media (max-width: 992px) {
  .m180-layout {
    grid-template-columns: minmax(0, 1fr);
  }
  .m180-rail {
    position: static;
  }
}
.m180-card {
  background: var(--m180-surface);
  border: 1px solid var(--m180-border);
  border-radius: var(--m180-radius);
  box-shadow: var(--m180-shadow);
  overflow: hidden;
}
.m180-card__head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: var(--m180-brand);
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}
.m180-card__chevron {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: var(--m180-brand-d);
  opacity: .75;
  flex: 0 0 auto;
}
.m180-card--collapsed > *:not(.m180-card__head) {
  display: none;
}
.m180-card__head mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: var(--m180-brand-d);
  opacity: .9;
}
.m180-card__head-label {
  flex: 1 1 auto;
  font-size: 13.5px;
  font-weight: 600;
  color: var(--m180-brand-d);
}
.m180-card__body {
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.m180-card__check {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: var(--m180-brand-d);
  flex: 0 0 auto;
}
.m180-card__foot {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding: 8px 14px 12px;
}
.m180-card:not(.m180-card--collapsed) > *:not(.m180-card__head) {
  animation: m180-reveal .2s ease;
}
@keyframes m180-reveal {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@media (max-width: 480px) {
  .m180-card__body {
    padding: 12px;
  }
}
.m180-rail__seccion:hover {
  background: rgba(227, 253, 100, .3);
}
.m180-rail__seccion--activa {
  background: var(--m180-brand);
  color: var(--m180-brand-d);
  font-weight: 600;
}
.m180-rail__seccion-check {
  color: var(--m180-brand-d);
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.m180-rail__seccion-hueco {
  width: 14px;
  height: 14px;
  border: 1px solid var(--m180-border);
  border-radius: 3px;
  flex: 0 0 auto;
}
/*# sourceMappingURL=model-180.component.css.map */
